import $ from "../util/dom.js";
import Api from "../api.js";
import Page from "./page.js";

let TranslationEditor = (()=>{
    let me = {};
    let translations = {};
    let listContainer;
    let button;

    async function loadTranslations(){
        let languages = ["en","fr"];

        let promises = languages.map(lang=>{
            let path = "_data/translations/" + lang + ".json?v=" + Date.now();
            return fetch(path).then(res=>res.json());
        })
        let results = await Promise.all(promises);
        results.forEach((res,i)=>{
            translations[languages[i]] = res;
        })

    }

    function updateTranslation() {
        let inputs = listContainer.querySelectorAll("input.lang");
        inputs.forEach(input=>{
            let id = input.id.split(":");
            let lang = id[0];
            let key = id[1];
            if (!translations[lang]){
                console.error("No translations for language",lang,key,input.value);
                console.error(input);
                translations[lang] = {};
            }
            translations[lang][key] = input.value;
        })
        console.log(translations);

        Page.waiting(true);
        if (button) {button.classList.add("loading"); button.disabled = true;}

        Api.update("translations",translations).then(result=>{
            console.log(result);
        }).catch(error=>{
            console.error(error);
        }).finally(()=>{
            Page.waiting(false);
            if (button) {button.classList.remove("loading"); button.disabled = false;}
        });
    }

    me.filter = (value)=>{
        if (!listContainer) return;
        let p = (value||"").toLowerCase();

        Array.from(listContainer.children).forEach(row=>{
            let key = row.querySelector(".key").innerText.toLowerCase();
            let match = key.indexOf(p)>=0;
            if (!match){
                let inputs = row.querySelectorAll("input");
                inputs.forEach(input=>{
                    if (input.value.toLowerCase().indexOf(p)>=0) match = true;
                });
            }
            row.style.display = match ? "" : "none";
        });
    }

    me.render=async container=>{
        container.innerHTML = "<center><br><div class='spinner'></div></center>";
        await loadTranslations();
        let editor = $(".translationeditor",
            $(".list",
                $(".header",$("label.cell","Key"),$("label.cell.wide","English"),$("label.cell.wide","French")),
                listContainer = $(".itemlist"),
                $(".buttons",{onClick:updateTranslation},button=$("button.primary.green",$(".spinner"),"Update"))
            )
        )

        let keys = Object.keys(translations.en);
        Object.keys(translations.fr).forEach(key=>{
            if (!keys.includes(key)) keys.push(key);
        })
        keys.sort();

        keys.forEach(key=>{
            let item = $(".row",
                $(".key.cell",key),
                $(".cell.wide",
                    $("input.lang",{type:"text",value:translations.en[key] || "", "id":"en:"+key})
                ),
                $(".cell.wide",
                    $("input.lang",{type:"text",value:translations.fr[key] || "", "id":"fr:"+key})
                )
            );
            listContainer.append(item);
        })

        container.innerHTML = "";
        container.append(editor);
    }

    return me;
})();
export default  TranslationEditor;